import { createFileRoute } from '@tanstack/react-router'

import { AiDeclineImpactScreen } from './-components/ai-decline-impact-screen.tsx'

export const Route = createFileRoute('/collections/ai-decline-impact')({
  component: AiDeclineImpactScreen
})
